// extracted by css-extract-rspack-plugin
export default {"commentsMenu":"vQ_hE","visible":"aV2AV"};